import DispatchConstants from '@common/constants/DispatchConstants';

const AppActions = {
  updateApp(data: any) {
    return (dispatch: any) =>
      dispatch({
        type: DispatchConstants.UPDATE_APP,
        payload: data,
      });
  },
  screenDimensionChange(screenWidth: number | null) {
    return (dispatch: any) =>
      dispatch({
        type: DispatchConstants.SCREEN_DIMENSION_CHANGE,
        payload: { screenWidth },
      });
  },
  setServerSideRedirect(to: string) {
    return (dispatch: any) => {
      dispatch({
        type: DispatchConstants.UPDATE_APP,
        payload: {
          setServerSideRedirect: to,
        },
      });
    };
  },
};

export default AppActions;
